import React from 'react'
import styled from 'styled-components'
import { WidgetProps } from '@rjsf/utils'
import { useSelector } from 'react-redux'
import { isKbChatNlpModelProvider } from '@feedyou/utils'

import { useSelectPortalRef } from '../../../../../../SelectPortalProvider'
import { botFlowSelector } from '../../../../../../../store/flow/selectors/botFlowSelector'
import { FeedbotSelect } from '../../../../../selects'

export const KnowledgeBaseSelectWidget: React.FC<WidgetProps> = ({
  value: kbId,
  onChange,
  uiSchema
}) => {
  const portalRef = useSelectPortalRef()
  const botFlow = useSelector(botFlowSelector)
  const knowledgeBases = [
    ...(botFlow?.knowledgeBases || []),
    ...(botFlow?.nlp?.models?.filter(isKbChatNlpModelProvider) || [])
  ]

  const options = knowledgeBases.map(kb => ({
    value: kb.id,
    label: kb.name || kb.id
  }))

  return (
    <Wrapper>
      <FeedbotSelect
        data-test="knowledge-base-select"
        placeholder="Select knowledge base"
        options={options}
        isClearable={uiSchema?.['ui:clearable'] !== false}
        menuPortalTarget={portalRef}
        value={options.find(opt => opt.value === kbId) || null}
        onChange={option => {
          onChange(option?.value || undefined)
        }}
      />
    </Wrapper>
  )
}

const Wrapper = styled.span`
  width: calc(80% - 26px);
`
